import FeatureFlagsService from 'garaje/services/feature-flags';

export default class UserFeatureFlagsService extends FeatureFlagsService {
  trafficType = 'user' as const;
}
